var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB1C26",
    fillRule: "evenodd",
    d: "M18.895 2.75h2.212l16.667 31.668-1.107 1.832H3.336l-1.107-1.832zM20 6.018 5.406 33.75h29.19zm1.25 7.733v9.166h-2.5V13.75zm-2.5 13.333h2.516v2.5h-2.516z",
    clipRule: "evenodd"
  })));
};
export default SvgExclamationTriangle;